import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NavigationPin_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 3.75C7.36945 3.75 5.25 5.85893 5.25 8.44444C5.25 9.71614 5.76074 10.8696 6.59416 11.7167L6.63026 11.7534L9.96908 16.2358C9.97455 16.2431 9.98552 16.25 10 16.25C10.0145 16.25 10.0254 16.2431 10.0309 16.2358L13.3697 11.7534L13.4058 11.7167C14.2392 10.8696 14.75 9.71615 14.75 8.44444C14.75 5.85893 12.6305 3.75 10 3.75ZM3.75 8.44444C3.75 5.01619 6.55542 2.25 10 2.25C13.4446 2.25 16.25 5.01619 16.25 8.44444C16.25 10.1085 15.5871 11.6194 14.5121 12.7307L11.2339 17.1318C10.9431 17.5222 10.4846 17.75 10 17.75C9.51534 17.75 9.05687 17.5222 8.76613 17.1318L5.48782 12.7307C4.41292 11.6194 3.75 10.1085 3.75 8.44444ZM10 6.25C8.75736 6.25 7.75 7.25736 7.75 8.5C7.75 9.74264 8.75736 10.75 10 10.75C11.2426 10.75 12.25 9.74264 12.25 8.5C12.25 7.25736 11.2426 6.25 10 6.25ZM6.25 8.5C6.25 6.42893 7.92893 4.75 10 4.75C12.0711 4.75 13.75 6.42893 13.75 8.5C13.75 10.5711 12.0711 12.25 10 12.25C7.92893 12.25 6.25 10.5711 6.25 8.5Z"
            />
        </SvgStyled>
    );
};

export default NavigationPin_sm;
